export default __webpack_public_path__ + "static/media/credas-logo.b3154cdb.svg";